<template>
<ComDialog :isShow="visible" :width="700" title="设置应用代理白名单" alignCenter @close="handleClose">
   <!-- 应用列表展示 -->
     <comForm
         ref="formRef"
        :formItem="formItem"
        :model="formData"
        :rules="rules"
        position="right">
    </comForm>
      <div class="app-list-container">
        <div class="app-list-header">
          <span class="title">应用列表</span>
          <el-input 
            v-model="searchKeyword" 
            placeholder="搜索应用名称"
            :suffix-icon="Search" 
            class="search-input"
            clearable
          />
        </div>
        <div class="app-list-content" v-loading="loadingAppList">
          <div v-if="filteredAppList.length > 0" class="app-grid">
            <!-- 点击应用图标选中 -->
            <div v-for="app in filteredAppList" :key="app.md5" class="app-grid-item" @click="selectApp(app)">
              <!-- 根据操作类型选择使用单选还是多选 -->
              <div class="app-selector">
                <el-checkbox  v-model="selectedAppIds" :label="app.md5" @click.stop></el-checkbox>
              </div>
              <div class="app-icon" >
                <img :src="app.logo" alt="app logo" />
              </div>
              <div class="app-name">{{ app.name }}</div>
            </div>
          </div>
          <div v-else class="empty-app-list">
            <div>{{ loadingAppList ? '加载中...' : '暂无应用数据' }}</div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" :loading="loading" :disabled="loading" @click="handleConfirm">确认</el-button>
      </div>
  </ComDialog>
</template>

<script setup>
import { ref, computed, defineExpose } from 'vue'
import ComDialog from "@/components/comDialog/index.vue";
import request from "@/utils/request";
import API_CONFIG from "../api.json";
import comForm from "@/components/comForm/index.vue";
import { ElMessage } from 'element-plus'

const visible = ref(false)
const deviceCode = ref('')
const loadingAppList = ref(false)
const selectedAppIds = ref([])
const searchKeyword = ref('')
const appList = ref([])
const loading = ref(false)
const formData = ref({
  proxyHost: '',
  proxyPort: '',
  proxyType: '',
  userName: '',
  ctrAlias: '',
  password: ''
})

const formItem = ref([
  {
    label: '设备编码',
    prop: 'ctrAlias',
    width:'120',
    type: 'input',
  },
  {
    label: '代理主机',
    prop: 'proxyHost',
    width:'120',
    type: 'input',
  },
   {
    label: '代理端口',
    prop: 'proxyPort',
    width:'120',
    type: 'input',
  },
  {
    label: '代理类型',
    prop: 'proxyType',
    width:'120',
    type: 'input',
  },
 {
    label: '代理账号',
    prop: 'userName',
    width:'120',
    type: 'input',
  },
 {
    label: '代理密码',
    prop: 'password',
    width:'120',
    type: 'input',
  }
])

const rules = ref({
  ctrAlias: [
    { required: true, message: '请输入设备编码', trigger: 'blur' }
  ],
  proxyHost: [
    { required: true, message: '请输入代理主机', trigger: 'blur' }
  ],
  proxyPort: [
    { required: true, message: '请输入代理端口', trigger: 'blur' }
  ],
  proxyType: [
    { required: true, message: '请输入代理类型', trigger: 'blur' }
  ],
  userName: [
    { required: true, message: '请输入代理账号', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入代理密码', trigger: 'blur' }
  ]
})

// 计算当前选中的应用对象
const selectedApps = computed(() => {
  // 多选模式
  if (!selectedAppIds.value || selectedAppIds.value.length === 0) return []
  return appList.value.filter(app => selectedAppIds.value.includes(app.md5))
})

// 根据搜索关键词过滤应用列表
const filteredAppList = computed(() => {
  if (!searchKeyword.value || searchKeyword.value.trim() === '') {
    return appList.value
  }
  
  const keyword = searchKeyword.value.toLowerCase().trim()
  return appList.value.filter(app => {
    // 应用名称模糊匹配
    const appName = app.name || app.fileName || ''
    return appName.toLowerCase().includes(keyword)
  })
})

const loadApps = async () => {
  loadingAppList.value = true
  request.post(API_CONFIG.batchGetInstallAppList.url, {
    ctrAliaList: [deviceCode.value]
  })
    .then((res) => {
      if (res.code === 0 && res.data && Array.isArray(res.data)) {
        appList.value = res.data
        // 重置选中状态
        if(formData.value.packageWhiteList){
           selectedAppIds.value = res.data.filter(app => formData.value.packageWhiteList.includes(app.packageName)).map(app => app.md5)
        }
      } else {
        appList.value = []
        selectedAppIds.value = []
      }
    })
    .catch((e) => {
      ElMessage.error('获取应用列表失败：' + e.message)
      appList.value = []
      selectedAppIds.value = []
    })
    .finally(() => {
      loadingAppList.value = false
    })
}

const selectApp = (app) => {
    // 多选模式下，点击应用图标切换选中状态
    const index = selectedAppIds.value.indexOf(app.md5)
    if (index === -1) {
      selectedAppIds.value.push(app.md5)
    } else {
      selectedAppIds.value.splice(index, 1)
    }
}

const handleClose = () => {
  visible.value = false
  selectedApps.value = []
  searchKeyword.value = ''
}

// 重绑代理并更新应用白名单
const handleConfirm = () => {
    loading.value = true
    const {ctrAlias, proxyHost, proxyPort, proxyType, userName, password} = formData.value
    request.post(API_CONFIG.setAppProxyWhiteList.url, [{
      ctrAlias,
      proxyHost,
      proxyPort,
      proxyType,
      userName,
      password,
      packageWhiteList: selectedApps.value.map(app => app.packageName).join(',')
    }])
    .then((res) => {
      if (res.code == 0) {
        ElMessage.success('设置成功')
        handleClose()
      } else {
        ElMessage.error('设置失败：' + res.msg || '未知错误')
      }
    })
    .catch((e) => {
      ElMessage.error('设置失败：' + e.message)
    })
    .finally(() => {
        loading.value = false
    })
}

// 获取当前设备代理配置
const getProxyConfig = async () => {
  request.post(API_CONFIG.getConfigureProxy.url, {
    ctrAliaList: [deviceCode.value]
  })
    .then((res) => {
      if (res.code === 0 && res.data && res.data.length > 0) {
       const {proxyHost, proxyPort, proxyType, proxyUserName, proxyPasswd, packageWhiteList} = res.data[0]
       formData.value = {
        ctrAlias: deviceCode.value,
        proxyHost,
        proxyPort,
        proxyType,
        userName: proxyUserName,
        password: proxyPasswd,
        packageWhiteList
       }
      } else {
        ElMessage.error('当前设备未配置代理或白名单为空，请重新配置')
      }
    })
    .catch((e) => {
      ElMessage.error('获取配置失败：' + e.message)
    })
}

const open = (row) => {
  deviceCode.value = row.code
  visible.value = true
  getProxyConfig()
  loadApps()
}

defineExpose({
  open
})
</script>

<style scoped>
.content {
  font-size: 14px;
  width: 100%;
  text-align: left;
  padding: 20px;
}

.app-list-container {
  margin-top: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.app-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  padding: 10px;
  .title {
    font-size: 14px;
    font-weight: 500;
  }
}

.search-input {
  width: 200px;
}

.app-list-content {
  max-height: 300px;
  overflow-y: auto;
  font-size: 14px;
}

.app-grid {
  padding: 10px;
  max-height: 30vh;
  overflow: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 15px;
}

.app-grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  transition: all 0.3s;
  position: relative;
  &:hover {
    background-color: #f5f7fa;
  }
}

.app-selector {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1;
}

.app-icon {
  width: 60px;
  height: 60px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }
}

.app-name {
  font-size: 12px;
  color: #333;
  text-align: center;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:deep(.el-checkbox__label),
:deep(.el-radio__label){
  display: none!important;
}

.empty-app-list {
  display: flex;
  width:   100%;
  flex-direction: column;
  justify-content: center;
  padding: 30px;
  color: #999;
  >div{
    text-align: center;
  }
}

.op-confirm-btn {
  text-align: center;
  padding: 20px 0;

  .el-button {
    width: 130px;
    height: 38px;
    border-radius: 20px;
    &:hover {
      opacity: 0.8;
    }
  }
}

.warning-tips {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 15px;
  display: block;
}
</style>